import script from "./InternalPurchaseOrderConfirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./InternalPurchaseOrderConfirmation.vue?vue&type=script&setup=true&lang=ts"

import "./InternalPurchaseOrderConfirmation.vue?vue&type=style&index=0&id=ce9c1978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce9c1978"]])

export default __exports__